import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AsamcoAuthService } from '@asamco/base';
import { User, UserService } from '@asamco/user-management/shared';
import { pathJoin, skipAuthInterceptor } from '@asamco/utils';
import { BehaviorSubject, combineLatest, from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuditLogData } from '../../interfaces/audit-log-data.interface';
import { Company } from '../../interfaces/company.interface';
import { SelectedCompanyService } from '../../selected-company/selected-company.service';
import { AsyncPipe, DatePipe } from '@angular/common';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoSelectionModule, DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule } from 'devextreme-angular';
import ODataStore from 'devextreme/data/odata/store';

@Component({
	selector: 'app-shell-admin-audit-logs-companies-users',
	templateUrl: './admin-audit-logs-companies-users.component.html',
	styleUrls: ['./admin-audit-logs-companies-users.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		DxDataGridModule,
		DxoSelectionModule,
		DxoFilterRowModule,
		DxiColumnModule,
		DxTemplateModule,
		AsyncPipe,
		DatePipe,
	],
})
export class AdminAuditLogsCompaniesUsersComponent implements OnInit {
	auditLogData: ODataStore<AuditLogData, any>;

	private userBehaviorSubject: BehaviorSubject<User[]> = new BehaviorSubject<User[]>(null);
	private companyBehaviorSubject: BehaviorSubject<Company[]> = new BehaviorSubject<Company[]>(null);

	constructor(
		private userService: UserService,
		private companyService: SelectedCompanyService,
		private auth: AsamcoAuthService,
		private http: HttpClient,
		private asamcoAuthService: AsamcoAuthService,
	) { }

	ngOnInit(): void {
		this.retrieveRequiredData();

		this.asamcoAuthService.authTokenChanged$.subscribe(
			(token) => {
				if (token.token) {
					this.auditLogData = new ODataStore<AuditLogData>({
						deserializeDates: false,
						url: this.asamcoAuthService.userSession.backend.odataBaseUrl + 'AuditLogData',
						version: 4,
						beforeSend: (e) => {
							e.headers = {
								"Authorization": `Bearer ${token.token}`,
								"X-Audit-Log-RecordType": 'Company,UserCompany,IUser',
							};
						}
					});
				}
			},
			(error) => {
				console.error('Error fetching the token:', error);
			}
		);
	}


	retrieveRequiredData() {
		combineLatest([this.userService.getAll(), this.companyService.getCompanies()]).subscribe(([users, companies]) => {
			this.userBehaviorSubject.next(users);
			this.companyBehaviorSubject.next(companies);
		});
	}

	public convertAdditionalDataToReadableText(auditLogData: AuditLogData): string {
		//1: Convert additionalData to corresponding object based on the RecordType
		if (auditLogData.recordType == 'Company') {
			let data = JSON.parse(auditLogData.additionalData);
			if (auditLogData.auditAction == 'CREATE') {
				return `A new company has been created with the name '${data.Name}'.`;
			}

			return '';
		} else if (auditLogData.recordType == 'UserCompany') {
			let data = JSON.parse(auditLogData.additionalData);
			let userName = this.userBehaviorSubject.value?.find(item => item.id == data.UserID)?.displayName || '?';
			let companyName = this.companyBehaviorSubject.value?.find(item => item.id == data.CompanyID)?.name || '?';
			if (auditLogData.auditAction == 'CREATE') {
				return `The user '${userName}' has been added to company '${companyName}'. Is the user the owner of the company: ${data.IsOwner}`;
			}
		} else if (auditLogData.recordType == 'IUser') {
			let data: User = JSON.parse(auditLogData.additionalData);
			if (auditLogData.auditAction == 'CREATE') {
				return `A new user has registered. Name: ${data.Username}, Email: ${data.Email}, Firstname: ${data.FirstName}, Lastname: ${data.LastName}`;
			}
		}

		return auditLogData.additionalData;
	}
}
